import { makeAutoObservable, observable } from "mobx";
import { get_symbolStar, get_tradeDeductionFee, checkoutAccount } from "api/v4/account";
import { get_privateUserVipInfo, get_userCountry } from "api/old/xt-user";

export interface UserInfoProps {
  userAccountLevel?: number; //1=主账户，2=子账户
  headImgUrl?: string;
  nickName?: string;
  userIdStr?: string;
  recommendCode?: string;
  accountId?: number;
  userVipLevel?: number;
}

export interface UserVipInfoProps {
  makerFeeRate: number;
  takerFeeRate: number;
  vipLevel: number;
  vipName: string;
  vipTakerFeeRate: number; //0.05
  vipMakerFeeRate: number; //0.05
}

export interface TradeDeductionFeeProps {
  deductEnable: boolean; //是否开启
  discountRate: string; //"0.25"
}

export interface UserCountry {
  countryId: number;
  countryName: string;
  countryCode: string;
}

interface StateProps {
  isLogin: boolean;
  token: string;
  userInfo: null | UserInfoProps;
  userVipInfo: WithUndefined<UserVipInfoProps>;
  symbolStar: string[];
  tradeDeductionFee: WithUndefined<TradeDeductionFeeProps>;
  userCountry: WithUndefined<UserCountry>;
  advancedStatus: WithUndefined<number>,
  addressAuth: WithUndefined<number>,
  isOpenAccount: WithUndefined<boolean>,
  // leverWsUserKey: string;
}

let loading_getUserVipInfo = false;
let loading_getTradeDeductionFee = false;

const user = makeAutoObservable(
  {
    isLogin: false as StateProps["isLogin"], //用户是否登录
    token: "" as StateProps["token"], //用户token
    userInfo: null as StateProps["userInfo"], //用户信息
    userVipInfo: undefined as StateProps["userVipInfo"], //用户vip费率信息
    symbolStar: [] as StateProps["symbolStar"], //用户自选的市场
    tradeDeductionFee: undefined as StateProps["tradeDeductionFee"], //用户交易手续费抵扣配置
    userCountry: undefined as StateProps["userCountry"], //用户ip信息
    // leverWsUserKey: "" as StateProps["leverWsUserKey"], //杠杆ws订阅userKey
    advancedStatus: undefined as StateProps["advancedStatus"], //用户是否实名认证 0:未提交 1:审核中 2:审核通过 3:审核不通过
    addressAuth: undefined as StateProps["addressAuth"], //用户地址认证 0:未认证 1:审核中 2:审核通过 3:审核不通过
    isOpenAccount: undefined as StateProps["isOpenAccount"], //用户是否股票开户

    get isSubAcc(): boolean {
      return !!(this.userInfo && this.userInfo.userAccountLevel === 2);
    }, //是否是子账户

    updateState(payload: Partial<StateProps>) {
      for (const va in payload) {
        this[va] = payload[va];
      }
    },

    getUserVipInfo() {
      if (loading_getUserVipInfo) return;
      loading_getUserVipInfo = true;

      get_privateUserVipInfo()
        .then((data) => (this.userVipInfo = data))
        .finally(() => {
          loading_getUserVipInfo = false;
        });
    },

    getUserCountry() {
      get_userCountry().then((data) => (this.userCountry = data));
    },
    getSymbolStar() {
      get_symbolStar().then((ary) => (this.symbolStar = ary));
    },
    getTradeDeductionFee() {
      if (loading_getTradeDeductionFee) return;
      loading_getTradeDeductionFee = true;

      get_tradeDeductionFee()
        .then((data) => (this.tradeDeductionFee = data))
        .finally(() => {
          loading_getTradeDeductionFee = false;
        });
    },
    getCheckUsreEquityStatus() {
      checkoutAccount().then((data) => {
        this.advancedStatus = data.advancedStatus;
        this.addressAuth = data.addressAuth;
        this.isOpenAccount = data.isOpenAccount;
      })
    },
  },
  {},
  {
    autoBind: true,
    deep: false,
  }
);

export default user;
